import { render, staticRenderFns } from "./uploadImages.vue?vue&type=template&id=c9a486f8&scoped=true&"
import script from "./uploadImages.vue?vue&type=script&lang=js&"
export * from "./uploadImages.vue?vue&type=script&lang=js&"
import style0 from "./uploadImages.vue?vue&type=style&index=0&id=c9a486f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a486f8",
  null
  
)

export default component.exports